import React, { useState } from 'react';
import { Button } from '@/components/shadcn/ui/button';
import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from '@/components/shadcn/ui/card';
import { Input } from '@/components/shadcn/ui/input';
import { Label } from '@/components/shadcn/ui/label';
import { Auth, createUserWithEmailAndPassword, updateProfile, sendEmailVerification } from 'firebase/auth';
import { auth } from '../../firebase'; // Importando a instância auth do firebase
import { useNavigate } from 'react-router-dom'; // Para navegação após o login
import pkg from '../../../package.json'

interface SignUpProps {
  auth: Auth;
}

const SignUp: React.FC<SignUpProps> = () => {
  const appVersion = pkg.version ;
  const [email, setEmail] = useState<string>(''); // Estado para o email
  const [password, setPassword] = useState<string>(''); // Estado para a senha
  const [confirmPassword, setConfirmPassword] = useState<string>(''); // Estado para confirmar senha
  const [name, setName] = useState<string>(''); // Estado para o nome
  const [error, setError] = useState<string | null>(null); // Estado para erros de autenticação
  const navigate = useNavigate(); // Hook para navegação entre páginas
  // Função para lidar com o submit do formulário de signup
  const handleSignUp = async (e: React.FormEvent) => {
    e.preventDefault();

    // Verificar se as senhas coincidem
    if (password !== confirmPassword) {
      setError('As senhas não coincidem.');
      return;
    }

        navigate('/company',{ state: {
          userEmail: email,
          userName: name,
          userPassword : password,
        }})
    
    
  };

  return (
    <div className="flex flex-col min-h-screen bg-indigo-200 justify-center items-center">
      <Card className="w-[450px] h-[550px]">
        <CardHeader>
          <CardTitle>Ainda não possui uma conta?</CardTitle>
          <CardDescription>Faça um novo cadastro</CardDescription>
        </CardHeader>
        <CardContent>
          <form>
            <div className="grid w-full items-center gap-6">
              <div className="flex flex-col space-y-1.5">
                <Label htmlFor="email">Endereço de email: </Label>
                <Input
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  type="email"
                  placeholder="Endereço de email"
                  required
                />
              </div>
              <div className="flex flex-col space-y-1.5">
                <Label htmlFor="name">Nome de usuário: </Label>
                <Input
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  type="text"
                  placeholder="Nome de usuário"
                  required
                />
              </div>
              <div className="flex flex-col space-y-1.5">
                <Label htmlFor="senha">Senha: </Label>
                <Input
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  type="password"
                  placeholder="Senha"
                  required
                />
              </div>
              <div className="flex flex-col space-y-1.5">
                <Label htmlFor="confirmar-senha">Confirmar Senha: </Label>
                <Input
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  type="password"
                  placeholder="Confirmar Senha"
                  required
                />
              </div>
              {error && <p className="text-red-500 text-sm">{error}</p>}
              <CardFooter className="mt-6 flex justify-between">
                <Button
                  type="submit"
                  onClick={handleSignUp}
                  className="bg-indigo-500 hover:bg-indigo-800 w-[130px]"
                >
                  Cadastrar
                </Button>
              </CardFooter>
            </div>
          </form>
        </CardContent>
      </Card>
      <footer className="w-full p-4 text-center bg-indigo-200">
        <p className="text-xs text-gray-800">©wCRM Versão {appVersion}</p>
      </footer>
    </div>
  );
};

export default SignUp;